import React from 'react';
import { ARCHETYPES } from '../../data/archetypes';
import type { ArchetypeResult } from '../../types/assessment';
type PrimaryArchetypeCardProps = {
  result: ArchetypeResult;
};
export function PrimaryArchetypeCard({
  result
}: PrimaryArchetypeCardProps) {
  const archetype = ARCHETYPES[result.key];
  return <article className="print-surface print-block overflow-hidden rounded-2xl bg-teal px-7 py-9 text-cream-light sm:px-10 sm:py-11" data-id="element-41" data-mp="1l4sd2im2b1ar">
      <p className="text-[10px] uppercase tracking-[0.18em] text-cream-light/65" data-id="element-42" data-mp="1g81yjzpwodrg">
        Your Primary Archetype
      </p>

      <span className="mt-3 block text-5xl leading-none" aria-hidden="true" data-id="element-43" data-mp="16gxisxseoovk">
        {archetype.emoji}
      </span>

      <h2 className="mt-3 font-display text-4xl font-bold leading-tight sm:text-5xl" data-id="element-44" data-mp="11i4d3rjd225y">
        The {archetype.name}
      </h2>
      <p className="mt-1.5 text-sm italic text-cream-light/80" data-id="element-45" data-mp="xf7tbxi3400f">{archetype.core}</p>

      <p className="mt-4 inline-block rounded-full bg-cream-light/15 px-3.5 py-1 text-[13px] font-medium" data-id="element-46" data-mp="sgwibjg1zjgm">
        {result.matchPct}% match
      </p>

      <p className="mt-5 max-w-prose text-[15px] font-light leading-[1.78] text-cream-light/90" data-id="element-47" data-mp="3sz09qhfo6c2r">
        {archetype.desc}
      </p>
    </article>;
}